export default [
  {
    name: 'auth/identity',
    path: '/auth/identity',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/auth/AuthIdentity.vue'),
  },
  {
    name: 'auth/accounts/sales',
    path: '/auth/accounts/sales',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/auth/AuthSalesAccount.vue'),
  },
  {
    name: 'auth/password-reset',
    path: '/auth/password-reset',
    meta: { requireSignin: false, design: { classes: ['fill-height', 'bg--linear-gradient'] } },
    component: () => import('@/pages/auth/PasswordReset.vue'),
  },
  {
    name: 'auth/accounts/hometax',
    path: '/auth/accounts/hometax',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/auth/AuthSalesAccountHometax.vue'),
  },
]
